// Vendor imports
const { connect } = require('react-redux')
// Common V2 imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
const articleActions = require('client-v2/common/models/article/actions')
const collectionActions = require('client-v2/common/models/collection/actions')
const userActions = require('client-v2/common/models/user/actions')
const deferDispatch = require('client-v2/common/state/dispatch')
// Sibling imports
const { defaultFeedActions } = require('./actions')
const Feed = require('./component-dumb')
const { defaultFeedSelectors } = require('./selectors')

module.exports = {
  createFeedSmartComponent,
  defaultFeedSmartComponent: createFeedSmartComponent(defaultFeedActions, defaultFeedSelectors)
}

function createFeedSmartComponent(feedActions, feedSelectors) {
  return {
    default: connect(mapStateToProps, mapDispatchToProps)(ImmutableToJS(Feed)),
    mapStateToProps,
    mapDispatchToProps,
    showArticleProfileModal
  }

  function mapStateToProps(state) {
    return {
      items: feedSelectors.getDenormalizedItems(state),
      selfUserId: state.user.loggedIn ? state.user.id : undefined,
      isMoreAvailable: feedSelectors.getIsNextPageAvailable(state)
    }
  }

  function mapDispatchToProps(dispatch) {
    const { dispatchAction, dispatchAuthRequiredAction } = deferDispatch(dispatch)
    return {
      onArticleAddClick: dispatchAuthRequiredAction(
        articleActions.showMixSelectModal,
        authModalActions.showSignup
      ),
      onArticleCardClick: dispatchAction(articleActions.navigateToArticleContent),
      onArticleCountClick: dispatchAction(showArticleProfileModal),
      onArticleDomainClick: dispatchAction(articleActions.navigateToArticleDomainSearch),
      onArticleEmbedClick: dispatchAction(articleActions.trackCardView),
      onArticleMoreClick: dispatchAuthRequiredAction(
        articleActions.showArticleActionsModal,
        authModalActions.showSignup
      ),
      onArticlePreviewClick: dispatchAction(showArticleProfileModal),
      onArticleSeen: dispatchAction(articleActions.trackGridView),
      onCollectionCardClick: dispatchAction(collectionActions.navigateToCollectionProfile),
      onCollectionCountClick: dispatchAction(collectionActions.navigateToCollectionProfileSubscribers),
      onCollectionFollowClick: dispatchAuthRequiredAction(
        collectionActions.toggleFollowing,
        authModalActions.showSignup
      ),
      onCollectionUsernameClick: dispatchAction(collectionActions.navigateToCollectionUserProfile),
      onMoreClick: dispatchAction(feedActions.loadMore),
      onUserCardClick: dispatchAction(userActions.navigateToUserProfile),
      onUserFollowClick: dispatchAuthRequiredAction(
        userActions.toggleFollowing,
        authModalActions.showSignup
      )
    }
  }

  function showArticleProfileModal(options) {
    if (options.event && options.event.altKey) {
      return articleActions.navigateToArticleProfile(options)
    }
    return feedActions.showArticleProfileModal(options)
  }
}
